import React, { useEffect, useState } from "react";
import { Form, OverlayTrigger, Table, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../_metronic/_helpers";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  showSuccessDialog,
  showErrorDialog,
  showConfirmDialog,
  useForceUpdate,
  checkPermision,
} from "../../utility";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import LoadingFetchData from "../../utility/LoadingFetchData";
import SVG from "react-inlinesvg";
import { Button, Col, Row } from "react-bootstrap";
import { NumberSequenceCreate } from "./NumberSequenceCreate";
import {
  addOfficeSequnce,
  fetchIdOffice,
  selectIdOffice,
  selectLoading,
  selectPermissionConfiguration,
} from "./officeSlice";
import {
  selectParameter6,
  selectParameter7,
} from "../businessParameter/businessParameterSlice";
import { selectNumberSequence } from "../businessGroup/businessGroupSlice";
import Select from "react-select";
import cellEditFactory from "react-bootstrap-table2-editor";
import { LayoutSplashScreen } from "../../../_metronic/layout";

export const Sequence = ({ tableData, setTableData, setActive }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const forceUpdate = useForceUpdate();
  const loading = useSelector(selectLoading);
  const dataPatern = useSelector(selectParameter7);
  const dataSequence = useSelector(selectNumberSequence);
  const dataIdOffice = useSelector(selectIdOffice);
  const permission = useSelector(selectPermissionConfiguration);

  console.log(tableData, "tableData");

  const getValueType = (value, options) => {
    const return_value = options.filter((val) => value === val.value);
    return return_value;
  };

  const handleSequence = (e) => {
    if (e === null) {
      e = undefined;
    } else {
    }
  };

  const sequenceOptions = dataSequence.map((e) => {
    return {
      value: e.sequence_id,
      label: e.sequence_name,
    };
  });

  const actionFormatter = (e, row) => {
    return (
      <>
        {checkPermision(permission, "UPDATE") && (
          <Button variant="primary" onClick={(e) => handleSave(row)}>
            Save
          </Button>
        )}
      </>
    );
  };

  const handleActionChange = async (e, row, rowIndex, formatExtraData) => {
    if (e === null) {
      formatExtraData[rowIndex].sequence_id = null;
    } else {
      formatExtraData[rowIndex].sequence_id = e.value;
    }
    console.log(formatExtraData, "formatExtraData");

    setTableData(formatExtraData);
    forceUpdate();
  };
  const sequenceFormatter = (cell, row, rowIndex, formatExtraData) => {
    return (
      <Select
        menuPortalTarget={document.body}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
        options={sequenceOptions}
        onChange={(e) => {
          handleActionChange(e, row, rowIndex, formatExtraData);
        }}
        isSearchable={false}
        placeholder="Select"
        value={getValueType(row.sequence_id, sequenceOptions)}
      />
    );
  };
  const handleRemarkRowChange = (e, row, rowIndex, formatExtraData) => {
    console.log(row, "row");
    console.log(formatExtraData, "formatExtraData");
    formatExtraData[rowIndex].pattern = e.target.value;
    setTableData(formatExtraData);
  };

  const paternFormatter = (e, row, rowIndex, formatExtraData) => {
    return (
      <div>
        <Form.Control
          value={row.pattern}
          onBlur={(e) =>
            handleRemarkRowChange(e, row, rowIndex, formatExtraData)
          }
          maxLength={255}
        />
      </div>
    );
  };

  const columns = [
    {
      text: "Module",
      dataField: "param_value",
      editable: false,
      headerAlign: "center",
    },
    {
      text: "Sequence",
      dataField: "sequence_id",
      formatter: sequenceFormatter,
      formatExtraData: tableData,
      editable: false,
      headerAlign: "center",
    },
    {
      text: "Pattern",
      dataField: "pattern",

      formatter: paternFormatter,
      formatExtraData: tableData,
      // editable: false,
      headerAlign: "center",
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: actionFormatter,
      editable: false,
      align: "center",
      headerAlign: "center",
    },
  ];

  const handleSaveAll = async () => {
    // {
    //   "no": 4,
    //   "module": "Inventory Status Update",
    //   "sequence": "159810e2-ce7f-4b96-94ca-1bfe8d3cda1d",
    //   "patern": "test 4"
    // }

    const params = tableData.map((item, index) => {
      return {
        office_id: dataIdOffice.office_id,
        module_code: item.param_code,
        sequence_id: item.sequence_id,
        pattern: item.pattern,

        param_code: item.param_code,
        param_value: item.param_value,
        office_name: dataIdOffice.office_name,
        sequence_name: item.module,
      };
    });

    try {
      const response = await dispatch(addOfficeSequnce(params));
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        if (action.isConfirmed)
          await dispatch(fetchIdOffice(dataIdOffice.office_id));
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleSave = async (row) => {
    // {
    //   "no": 4,
    //   "module": "Inventory Status Update",
    //   "sequence": "159810e2-ce7f-4b96-94ca-1bfe8d3cda1d",
    //   "patern": "test 4"
    // }

    console.log(row, "row");

    const params = [
      {
        office_id: dataIdOffice.office_id,
        module_code: row.param_code,
        sequence_id: row.sequence_id,
        pattern: row.pattern,

        param_code: row.param_code,
        param_value: row.param_value,
        office_name: dataIdOffice.office_name,
        sequence_name: row.sequence_name,
      },
    ];

    try {
      const response = await dispatch(addOfficeSequnce(params));
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        if (action.isConfirmed)
          await dispatch(fetchIdOffice(dataIdOffice.office_id));
        } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <BootstrapTable
        wrapperClasses="table-responsive"
        classes="table table-head-custom table-vertical-center overflow-hidden rounded mt-5"
        bootstrap4
        
        keyField="no"
        data={tableData}
        columns={columns}
        hover
        striped
        cellEdit={cellEditFactory({
          mode: "click",
          blurToSave: true,
        })}
      >
        <PleaseWaitMessage entities={loading ? null : tableData} />
        <NoRecordsFoundMessage entities={loading ? null : tableData} />
      </BootstrapTable>
      {checkPermision(permission, "UPDATE") && (
        <Row className="mt-6 mr-6 justify-content-end">
          <Button variant="primary" onClick={handleSaveAll}>
            Save All
          </Button>
        </Row>
      )}
      <div className="">
        {/* Head */}
        <div className="card-header border-0">
          <h2 className="card-title font-weight-bolder text-dark mb-0 ">
            Pattern Keywords Description{" "}
          </h2>
        </div>
        {/* Body */}
        <Table striped>
          <thead>
            <tr></tr>
          </thead>
          <tbody>
            {dataPatern.map((item, index) => {
              return (
                <tr>
                  <td>
                    <label>
                      <b>{item.param_code}</b>
                    </label>
                  </td>
                  <td>
                    <label>
                      <b>
                        : Use this keyword in pattern to enable system to render
                        the {item.param_value}
                      </b>
                    </label>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    </>
  );
};
